import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import PageRoutes from "./PageRoutes";

// DXP components
import DxpPartnerPortalLandingPage from "../PartnerPortalLandingPage";
import DxpAlreadyRegistered from "../ConfirmationPages/AlreadyRegistered";
import RegistrationWizardWrapper from "../RegistrationWizardWrapper";
import RegistrationComponentsPreview from "../RegistrationComponentsPreview";
import DxpRegisteredWithAnotherProgram from "../ConfirmationPages/RegisteredWithAnotherProgram";
import DxpRegistrationSuccessMessage from "../ConfirmationPages/RegistrationSuccessMessage";
import DxpRegistrationPendingMessage from "../ConfirmationPages/RegistrationPendingMessage";
import DxpSameDomainInactiveMessage from "../SameDomainInactiveMessage";
import DxpDifferentDomainInactiveMessage from "../DifferentDomainInactiveMessage";
import DxpPendingApproval from "../ConfirmationPages/PendingApproval";
import DxpAlreadyRegisteredWithAnotherProgram from "../AlreadyRegisteredWithAnotherProgram";
import DxpInviteContact from "../InviteContact";
import DxpEmailMismatch from "../ConfirmationPages/EmailMismatch";

function MainContainer() {
  const attachJarvis = () => {
    const chatLinks = document.querySelectorAll("a[href='#openjarvis']");
    chatLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        window.feds?.services?.jarvis?.openChat();
      });
    });
  };

  const loadGNav = () => {
    if (!window.footerInitialized) {
      window.footerInitialized = true;

      const gNav = window.milo?.gNav;
      if (!gNav?.jslib) {
        return;
      }

      const { authoringPath } = gNav;
      const env = gNav.environment || "stage";
      const privacyId = new URLSearchParams(window.location.search).get(
        "privacyid",
      );
      const locale = "en";
      const theme = "light";

      const miloGNavScript = document.createElement("script");
      miloGNavScript.src = gNav.jslib;
      miloGNavScript.type = "module";
      miloGNavScript.async = true;
      document.body.appendChild(miloGNavScript);

      miloGNavScript.onload = () => {
        window.loadNavigation?.({
          env,
          locale,
          theme,
          authoringPath,
          header: {
            unav: {
              unavComponents: "jarvis",
            },
            jarvis: { id: "spp_default" },
          },
          footer: {
            authoringPath,
            privacyId,
          },
        });
      };
    }
  };

  useEffect(() => {
    window.addEventListener("feds.events.experience.loaded", () => {
      attachJarvis();
    });
    loadGNav();
  }, []);

  return (
    <div className="MainContainer">
      <div id="feds-header" className="dxp-feds-header-placeholder" />
      <Routes>
        <Route element={<PageRoutes programTypeValue="90001" />}>
          <Route path="/" element={<RegistrationWizardWrapper />} />
          <Route
            path="registration-components-preview"
            element={<RegistrationComponentsPreview />}
          />
          <Route
            path="partner-registration-home"
            element={<DxpPartnerPortalLandingPage />}
          />
          <Route path="already-registered" element={<DxpAlreadyRegistered />} />
          <Route
            path="already-registered-with-another-program"
            element={<DxpAlreadyRegisteredWithAnotherProgram />}
          />
          <Route
            path="registered-with-another-program"
            element={<DxpRegisteredWithAnotherProgram />}
          />
          <Route
            path="request-submitted"
            element={<DxpRegistrationSuccessMessage />}
          />
          <Route
            path="save-success"
            element={<DxpRegistrationSuccessMessage type="saveExit" />}
          />
          <Route
            path="continue-registration"
            element={
              <DxpRegistrationSuccessMessage type="continueRegistration" />
            }
          />
          <Route path="pending-approval" element={<DxpPendingApproval />} />
          <Route
            path="invited-contact-registration"
            element={<DxpInviteContact />}
          />
          <Route path="email-mismatch" element={<DxpEmailMismatch />} />
          <Route
            path="invalid-contact"
            element={<DxpInviteContact type="invalid" />}
          />
          <Route
            path="request-pending"
            element={<DxpRegistrationPendingMessage />}
          />
          <Route
            path="same-domain-contact-inactive"
            element={<DxpSameDomainInactiveMessage />}
          />
          <Route
            path="different-domain-contact-inactive"
            element={<DxpDifferentDomainInactiveMessage />}
          />
        </Route>
        <Route
          path="*"
          element={
            <main className="dxp-route-not-found-main">
              <p>There&apos;s nothing here!</p>
            </main>
          }
        />
      </Routes>
    </div>
  );
}

export default MainContainer;
